/**
 * Created by Min on 2017/2/9.
 */
import React, { Component } from 'react';

// From: https://github.com/tobiasahlin/SpinKit

export default class Spinner extends Component {
    render() {
        return (
            <div className="dmloader-cube-grid">
                <div className="dmloader-cube dmloader-cube1" />
                <div className="dmloader-cube dmloader-cube2" />
                <div className="dmloader-cube dmloader-cube3" />
                <div className="dmloader-cube dmloader-cube4" />
                <div className="dmloader-cube dmloader-cube5" />
                <div className="dmloader-cube dmloader-cube6" />
                <div className="dmloader-cube dmloader-cube7" />
                <div className="dmloader-cube dmloader-cube8" />
                <div className="dmloader-cube dmloader-cube9" />
            </div>
        );
    }
}
